// global shared items
require('./shared')

require('./shared_functions')

require('../site_scripts/mtc_accordions')
require('../global/read-more');

// page specific styles
require('../../styles/entry/motability-landing.less')
